import {
  EditBlockCheckBox,
  EditBlockColorPicker,
  EditBlockNumericInput,
  EditBlockPosition,
  EditBlockSelect,
  EditBlockSwitch,
  EditBlockUpload,
} from '@components/EditBuildingBlocks/all'
import { mapActions, mapState } from 'vuex'
import { maxWidth } from '@meta/widget/options'

export default {
  props: {
    widget: {
      required: true,
      type: Object,
    },
    showWidgetSettings: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  components: {
    'edit-block-color-picker': EditBlockColorPicker,
    'edit-block-position': EditBlockPosition,
    'edit-block-checkbox': EditBlockCheckBox,
    'edit-block-upload': EditBlockUpload,
    'edit-block-select': EditBlockSelect,
    'edit-block-switch': EditBlockSwitch,
    'edit-block-numeric-input': EditBlockNumericInput,
  },
  data() {
    return {
      maxWidthOptions: maxWidth,
    }
  },
  computed: {
    ...mapState('editor', [
      'availableFontsList',
      'headlineFontSizesList',
      'textFontSizesList',
      'showContentMenu',
      'showSettingsMenu',
    ]),
    targetStepID() {
      return this.$store.state.campaign.step.targetStepID
    },
    targetContentItemID() {
      return this.$store.state.campaign.contentItem.targetContentItemID
    },
    targetContentItem() {
      return this.widget.steps?.[this.targetStepID]?.contentItems?.[this.targetContentItemID]
    },
    widgetMaxWidth: {
      get() {
        return this.widget.styling.maxWidth
      },
      set(value) {
        this.updateWidgetStyling({
          id: this.widget.id,
          path: ['maxWidth'],
          styling: value,
        })
      },
    },
    widgetBgColor: {
      get() {
        return this.widget.styling.backgroundColor
      },
      set(value) {
        this.updateWidgetStyling({
          id: this.widget.id,
          path: ['backgroundColor'],
          styling: value,
        })
      },
    },
    widgetBgImage: {
      get() {
        return this.widget.styling.backgroundImage
      },
      set(value) {
        // Transform value to valid css
        const imgURL = 'url("' + value + '")'
        this.updateWidgetStyling({
          id: this.widget.id,
          path: ['backgroundImage'],
          styling: imgURL,
        })
      },
    },
    widgetBgSize: {
      get() {
        return this.widget.styling.backgroundSize
      },
      set(value) {
        this.updateWidgetStyling({
          id: this.widget.id,
          path: ['backgroundSize'],
          styling: value,
        })
      },
    },
    widgetBorderRadius: {
      get() {
        return this.widget.styling.borderRadius !== 0
      },
      set(value) {
        value = value ? '40px' : 0
        this.updateWidgetStyling({
          id: this.widget.id,
          path: ['borderRadius'],
          styling: value,
        })
      },
    },
    widgetCloseButton: {
      get() {
        return this.widget.settings.closeButton
      },
      set(value) {
        this.updateWidgetSettings({
          id: this.widget.id,
          path: ['closeButton'],
          settings: value,
        })
      },
    },
    widgetCloseOnOverlayClick: {
      get() {
        return this.widget.settings.closeOnOverlayClick
      },
      set(value) {
        this.updateWidgetSettings({
          id: this.widget.id,
          path: ['closeOnOverlayClick'],
          settings: value,
        })
      },
    },
    widgetCloseButtonColor: {
      get() {
        return this.widget.settings.closeButtonColor
      },
      set(value) {
        this.updateWidgetSettings({
          id: this.widget.id,
          path: ['closeButtonColor'],
          settings: value,
        })
      },
    },
    widgetHideMobile: {
      get() {
        return this.widget.settings.hideMobile
      },
      set(value) {
        this.updateWidgetSettings({
          id: this.widget.id,
          path: ['hideMobile'],
          settings: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('campaign/widget',
      ['updateWidgetStyling', 'updateWidgetSettings']),
  },
}
